import { render, staticRenderFns } from "./Verifikasi.vue?vue&type=template&id=2634f11e&scoped=true&"
import script from "./Verifikasi.vue?vue&type=script&lang=js&"
export * from "./Verifikasi.vue?vue&type=script&lang=js&"
import style0 from "./Verifikasi.vue?vue&type=style&index=0&id=2634f11e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2634f11e",
  null
  
)

export default component.exports